<template>
  <div>
    <v-btn
      color="primary"
      outlined
      small
      @click="show_dialog = true"
    >
      <v-icon
        left
        small
      >mdi-palette</v-icon>
      Change Template
    </v-btn>
    <div class="text-caption text--secondary mt-1">
      Update styling and layout from a template while preserving your custom settings
    </div>

    <v-dialog
      v-model="show_dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          <v-icon
            left
            color="primary"
          >mdi-alert</v-icon>
          Change Template
        </v-card-title>

        <v-card-text>
          <v-alert class="shaded-light mt-1 mb-3">
            <div class="font-weight-bold mb-3">This will update your form's styling and layout</div>
            <div class="text-body-2">
              The following <u>should update</u>:
              <slot name="will-update-items">
                <ul class="mt-2">
                  <li
                    v-for="item in will_update_items"
                    :key="item"
                  >{{ item }}</li>
                </ul>
              </slot>
            </div>
            <div class="text-body-2 mt-3">
              The following <u>should be preserved</u>:
              <slot name="will-preserve-items">
                <ul class="mt-2">
                  <li
                    v-for="item in will_preserve_items"
                    :key="item"
                  >{{ item }}</li>
                </ul>
              </slot>
            </div>
          </v-alert>
          <div class="text-body-1">
            You will be redirected to the template selection screen to choose a new template.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="show_dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="handleContinue"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * The button and accompanying dialog to re-apply a template to a widget form.
 */

export default {
  name: 'WidgetEditorReapplyTemplate',

  props: {
    /**
     * Form ID for the widget being edited
     */
    form_id: {
      type: String,
      required: true,
    },

    /**
     * Route name for the template selection screen
     * e.g., 'order-confirmation-template-selection', 'guest-check-in-template-selection'
     */
    template_selection_route: {
      type: String,
      required: true,
    },

    /**
     * Array of items that will be updated when re-applying the template
     * Defaults to common styling elements
     */
    will_update_items: {
      type: Array,
      default: () => [
        'All colors and fonts (theme settings)',
        'All text styling and layout elements',
        'Button styles and container layouts',
      ],
    },

    /**
     * Array of items that will be preserved when re-applying the template
     * Defaults to common form elements
     */
    will_preserve_items: {
      type: Array,
      default: () => [
        'Settings name and configuration',
        'Consent gathering settings',
        'CRM integration settings',
        'List assignments and inbox settings',
      ],
    },
  },

  data() {
    return {
      show_dialog: false,
    };
  },

  methods: {
    handleContinue() {
      this.show_dialog = false;

      this.$router.push({
        name: this.template_selection_route,
        params: {
          organization_id: this.$rc.getOrganizationId(),
        },
        query: {
          re_apply: 'true',
          form_id: this.form_id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
